import React from "react";
import { Modal } from "antd";
import FormRenderer from "../Form";

interface FormModalProps {
	visible: boolean;
	onClose: () => void;
	formId: number;
	/**
	 * The assignment's access token, taken from the patient's own assigned-forms listing.
	 * The modal has no URL to read `?t=` from, so it must be handed down. Optional: while
	 * healthcare's `forms.require_access_token` grace period is on, a legacy assignment
	 * without a token still renders.
	 */
	accessToken?: string;
	title?: string;
}

const FormModal: React.FC<FormModalProps> = ({ visible, onClose, formId, accessToken, title = "Form" }) => {
	return (
		<Modal
			title={title}
			open={visible}
			onCancel={onClose}
			footer={null}
			width="90%"
			style={{ maxWidth: 800 }}
			destroyOnClose
		>
			<FormRenderer
				formId={formId}
				accessToken={accessToken}
				isModal={true}
				onComplete={onClose}
			/>
		</Modal>
	);
};

export default FormModal;